import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Container from '../../../components/dashboard/container';
import { isAeroAdmin } from '../../../components/access';
import { withAuthorization } from '../../../model/Session';
import * as ROUTES from '../../../constants/routes';
import { FirebasePropType, withFirebase } from '../../../model/Firebase';
import Fields from './fields';
import Loading from '../../../components/loading';
import PilotoForm from './pilotForm';

const EditPiloto = ({ firebase, match, history }) => {
  const [pilot, setPilot] = React.useState(Fields.defaultValues());
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    const { id } = match.params;
    let unsubscribe;
    if (id) {
      unsubscribe = firebase.pilot(id)
        .onSnapshot((doc) => {
          const codPilot = Fields.getInstance(doc);
          setPilot(codPilot);
          setLoading(false);
        }, () => history.push(ROUTES.PILOTOS));
    } else {
      history.push(ROUTES.PILOTOS);
    }
    return () => !!unsubscribe && unsubscribe();
  }, [firebase, history, match.params]);

  return (
    <Container
      backPath={ROUTES.PILOTOS}
      title={`Piloto: ${pilot.docNumber} - ${pilot.firstName} ${pilot.lastName}`}
    >
      <Grid container spacing={3} justify="center">
        <Grid item xs={12} md={6}>
          {loading ? (
            <Loading />
          ) : (
            <PilotoForm isNew={false} defaultValues={pilot} />
          )}
        </Grid>
      </Grid>
    </Container>
  );
};

EditPiloto.propTypes = {
  firebase: FirebasePropType.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default compose(
  withAuthorization(isAeroAdmin),
  withFirebase,
  withRouter,
)(EditPiloto);
